import { render, staticRenderFns } from "./preview-bulk-recipients.vue?vue&type=template&id=6bc2d00e&scoped=true&"
import script from "./preview-bulk-recipients.vue?vue&type=script&lang=js&"
export * from "./preview-bulk-recipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2d00e",
  null
  
)

export default component.exports